import BreadcrumbWrapper from '../BreadcrumbWrapper';
import InviteCodesList from './InviteCodesList.tsx';

const InviteCodes = () => {
  return (
    <div className="flex flex-col gap-4">
      <BreadcrumbWrapper
        crumbArray={[{ path: '/invite-codes', label: 'Invite Codes' }]}
      />

      <h1 className="text-2xl font-bold">Invite Codes</h1>
      <p>Manage Invite Codes</p>
      <InviteCodesList />
    </div>
  );
};

export default InviteCodes;
